import React from 'react';
import { Image, QRCode, Typography, Button } from 'antd';

const { Text, Link } = Typography;

/**
 * LbsPreview - 预览组件（海报背景 + 顶部重新定位按钮 + 底部信息卡片）
 * 支持二维码链接(qrCodeUrl)或二维码内容(qrCodeValue)。
 */
const LbsPreview = ({
  posterUrl,
  qrCodeUrl,
  qrCodeValue,
  storeName = '测试门店',
  storeAddress = '',
  distanceText = '约 0.5km',
  onRelocate,
  onManualSwitch,
  width = '100%',
  height,
  designWidth = 750,
  designHeight = 1624
}) => {
  const containerStyle = {
    width: width,
    ...(height ? { height } : { aspectRatio: `${designWidth} / ${designHeight}` }),
    position: 'relative',
    borderRadius: 18,
    overflow: 'hidden',
    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
    background: '#eaeaea'
  };

  const bgStyle = {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    filter: 'none'
  };

  const maskStyle = {
    position: 'absolute',
    inset: 0,
    background: 'rgba(0,0,0,0.15)'
  };

  // 顶部操作行（右侧“重新定位”），位于门店信息之上
  const topActionsStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 6
  };

  const cardStyle = {
    position: 'absolute',
    left: 10,
    right: 10,
    bottom: 10,
    background: '#fff',
    borderRadius: 14,
    padding: '12px 12px 10px',
    boxShadow: '0 12px 32px rgba(0,0,0,0.18)',
    zIndex: 2,
    textAlign: 'center'
  };

  const nameStyle = {
    fontSize: 16,
    fontWeight: 700,
    color: '#111',
    marginBottom: 6
  };

  const addrStyle = {
    fontSize: 12,
    color: '#666',
    marginBottom: 12
  };

  const metaStyle = {
    fontSize: 11,
    color: '#8c8c8c',
    marginTop: -4,
    marginBottom: 6
  };

  const qrWrapStyle = {
    padding: '6px 0 4px',
    display: 'flex',
    justifyContent: 'center'
  };

  const qrInnerStyle = {
    position: 'relative',
    display: 'inline-block'
  };

  const tipStyle = {
    fontSize: 12,
    color: '#888',
    marginTop: 6,
    marginBottom: 6
  };

  return (
    <div style={containerStyle}>
      {posterUrl ? (
        <img src={posterUrl} alt="poster" style={bgStyle} />
      ) : (
        <div style={{ ...bgStyle, background: '#f5f5f5' }} />
      )}
      <div style={maskStyle} />

      <div style={cardStyle}>
        <div style={topActionsStyle}>
          <Button type="default" size="small" shape="round" onClick={onRelocate}>重新定位</Button>
        </div>
        <div style={nameStyle}>{storeName}</div>
        <div style={metaStyle}>📍 距您 {distanceText}</div>
        {storeAddress ? <div style={addrStyle}>{storeAddress}</div> : null}

        <div style={qrWrapStyle}>
          <div style={qrInnerStyle}>
            {qrCodeUrl ? (
              <Image src={qrCodeUrl} alt="二维码" width={140} preview={false} />
            ) : qrCodeValue ? (
              <QRCode value={qrCodeValue} size={140} />
            ) : (
              <Text type="secondary">暂无二维码</Text>
            )}
          </div>
        </div>

        <div style={tipStyle}>长按识别添加</div>

        <div>
          <Link onClick={onManualSwitch}>这不是我附近的门店，点此手动切换</Link>
        </div>
      </div>
    </div>
  );
};

export default LbsPreview;